import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { exchangeSession } from "@/lib/userApi";

/** Handles the session_id URL fragment after Google Auth returns.
 *  Called synchronously from AppRouter when window.location.hash has session_id=.
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);

    (async () => {
      try {
        const data = await exchangeSession(session_id);
        // Clean fragment before landing.
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/me", { replace: true, state: { user: data.user } });
      } catch (e) {
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/", { replace: true, state: { authError: true } });
      }
    })();
  }, [navigate]);

  return (
    <div data-testid="auth-callback" className="min-h-screen bg-white flex items-center justify-center font-mono text-xs uppercase tracking-widest text-[#52525b]">
      Finalizing sign-in…
    </div>
  );
}
